<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.advTitle"
            placeholder="广告标题"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.img_type"
                  placeholder="分类"
                  width="50"
                  @change="handleSelectChange"
          >
            <el-option
                    v-for="item in tpOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.type"
                  placeholder="内容"
                  width="50"
                  v-if="isholiday"
          >
            <el-option
                    v-for="item in ztOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="标题"
      >
        <template slot-scope="scope">
          {{scope.row.advTitle}}
        </template>
      </el-table-column>
      <el-table-column
        label="图片"
        :show-overflow-tooltip="true"
        width="350"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.media_type=='2'">
            <video
                    v-bind:src="getImgUrl(scope.row)"
                    class="avatar video-avatar"
                    controls="controls"  style="width: 200px;height: 100px; "></video>
          </div>
          <div v-else-if="scope.row.media_type=='3'">
            <audio controls ref="audio"  class="aud">

              <source :src="getImgUrl(scope.row)" />

            </audio>
          </div>
          <div v-else>
            <img :src= "getImgUrl(scope.row)" style="width: 150px;height: 150px; "/>
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="广告链接"
              width="200"
      >
        <template slot-scope="scope">
          {{scope.row.advUrl}}
        </template>
      </el-table-column>
      <el-table-column
              label="广告位编号"
      >
        <template slot-scope="scope">
          {{scope.row.advPos}}
        </template>
      </el-table-column>
      <el-table-column
        label="图片类型"
        prop="sort_id"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.img_type=='1'">
            经络图
          </div>
          <div v-else-if="scope.row.img_type=='2'">
            生日
          </div>
          <div v-else-if="scope.row.img_type=='3'">
            生肖
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="排序"
      >
        <template slot-scope="scope">
          {{scope.row.advSort}}
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            正常
          </div>
          <div v-else-if="scope.row.state=='1'">
           禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openEditForm(scope.row)"
          >编辑</el-button>
            <el-button
                    v-if="scope.row.state=='0'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,1)"
            >禁用</el-button>
            <el-button
                    v-if="scope.row.state=='1'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,0)"
            >恢复</el-button>

          <el-button
            type="primary"
            plain
            size="mini"
            @click="del(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as oneclassService from '@/api/sys/oneclass'
import * as agentService from '@/api/sys/agent'
import editForm from './editForm'
import util from '@/libs/util.js'
export default {
  name: 'SmallposterPage',
  components: { editForm },
  data () {
    return {
      searchForm: {
        advTitle: ''
      },
      loading: false,
      tableData: [],
      isholiday: false,
      multipleSelection: [],
      tpOptions: [

        {
          value: '1',
          label: '经络图'
        },
        {
          value: '2',
          label: '生日'
        },
        {
          value: '3',
          label: '生肖'
        }
      ],
      typeOptions: [
        {
          value: '0',
          label: '正常'
        },
        {
          value: '1',
          label: '禁用'
        }
      ],
      sxOptions: [

        {
          value: '鼠',
          label: '鼠'
        },
        {
          value: '牛',
          label: '牛'
        },
        {
          value: '虎',
          label: '虎'
        },
        {
          value: '兔',
          label: '兔'
        },
        {
          value: '龙',
          label: '龙'
        },
        {
          value: '蛇',
          label: '蛇'
        },
        {
          value: '马',
          label: '马'
        },
        {
          value: '羊',
          label: '羊'
        },
        {
          value: '猴',
          label: '猴'
        },
        {
          value: '鸡',
          label: '鸡'
        },
        {
          value: '狗',
          label: '狗'
        },
        {
          value: '猪',
          label: '猪'
        }
      ],
      ztOptions: [],
      ztOptions2: [

        {
          value: ',1,2,',
          label: '1-3'
        },
        {
          value: ',3,4,',
          label: '3-5'
        },
        {
          value: ',5,6,',
          label: '5－7'
        },
        {
          value: ',7,8,',
          label: '7－9'
        },
        {
          value: ',9,10,',
          label: '9－11'
        },
        {
          value: ',11,12,',
          label: '11－13'
        },
        {
          value: ',13,14,',
          label: '13－15'
        },
        {
          value: ',15,16,',
          label: '15－17'
        },
        {
          value: ',17,18,',
          label: '17－19'
        },
        {
          value: ',19,20,',
          label: '19－21'
        },
        {
          value: ',21,22,',
          label: '21－23'
        },
        {
          value: ',23,0,',
          label: '23－1'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      oneclass: {},
      clicksFormVisible: false,
      exposureFormVisible: false,
      editFormVisible: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        agentid: util.cookies.get('agentid'),
        xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      agentService.getAdvertJlPagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    getImgUrl (row) {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + row.advImg
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSelectChange (type) {
      if (type == '1' || type == '3') {
        this.isholiday = true
        if (type == '3') {
          this.ztOptions = this.sxOptions
        } else {
          this.ztOptions = this.ztOptions2
        }
      } else {
        this.isholiday = false
      }
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openEditForm (oneclass) {
      this.oneclass = oneclass
      this.editFormVisible = true
    },
    openExposureForm (oneclass) {
      this.oneclass = oneclass
      this.exposureFormVisible = true
    },
    openClicksForm (oneclass) {
      this.oneclass = oneclass
      this.clicksFormVisible = true
    },

    add () {
      this.oneclass = {}
      this.editFormVisible = true
    },
    batchDel () {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        agentService
          .batchAdvertJl({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData()
          })
      })
    },
    update (id, type) {
      let msg = type == 1 ? '禁用' : '恢复'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        agentService.updateAdvertJl({ id: id, state: type }).then(() => {
          this.getTableData()
        })
      })
    },
    del (id) {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        agentService.delAdvertJl({ id: id }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
